module.exports = __webpack_public_path__ + "static/media/CNews8.3e8e519a.png";